import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import imagePng from "images/travelhero2.png";

export interface SectionHero3Props {
  className?: string;
}

const SectionHero3: FC<SectionHero3Props> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero3 relative ${className}`}
      data-nc-id="SectionHero3"
    >
      <div className="absolute z-10 inset-x-0 top-[30%] sm:top-[15%] text-center flex flex-col items-center max-w-2xl mx-auto space-y-4 lg:space-y-5 xl:space-y-8">
        <span className="sm:text-lg md:text-xl font-semibold text-neutral-100">
          Lokalai is a flatform to offers
        </span>
        <h2 className="font-bold text-white text-3xl sm:text-4xl md:text-6xl lg:text-7xl xl:text-8xl !leading-[115%] ">
          All The <br /> Best Deals
        </h2>
        <ButtonPrimary
          sizeClass="px-6 py-3 lg:px-8 lg:py-4 rounded-xl"
          fontSize="text-sm sm:text-base lg:text-lg font-medium"
        >
          Explore What's On
        </ButtonPrimary>
      </div>
      <div className="relative aspect-w-1 aspect-h-1 sm:aspect-w-4 sm:aspect-h-3 lg:aspect-w-16 lg:aspect-h-9 xl:aspect-h-8 ">
        <img
          className="absolute inset-0 object-cover rounded-xl"
          // src={imagePng}
          src={"https://images.pexels.com/photos/7957754/pexels-photo-7957754.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}
          alt="hero"
        />
      </div>
    </div>
  );
};

export default SectionHero3;
